import Dashboard from 'pages/dashboards';
import Home from 'pages/home';
import  {BrowserRouter, Switch, Route} from 'react-router-dom';

function Routes(){
    return (
        <BrowserRouter>

            <Switch>
                <Route path="/" exact>
                    <Home/>
                </Route>
                <Route path="/dashboard">
                    <Dashboard/>
                </Route>
            </Switch>
        </BrowserRouter>
    );
}

export default Routes;